import React, { useState, useEffect } from 'react';
import {
  GeckoModal,
  GeckoModalService,
  GECKO_CONSTS,
  GeckoToastService,
} from '../../../ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { GeckoFields } from '../../../ui';
import { useSelector } from 'react-redux';
import TagSelect from 'components/TagSelect';

const AddTagsModal = ({ conversation, setActionTimestamp }) => {
  const [newAssignedTagIds, setNewAssignedTagIds] = useState([]);

  const assignedTagIds = conversation.tagIds;

  const tags = useSelector((state) => state.tags);

  useEffect(() => {
    setNewAssignedTagIds(assignedTagIds);
  }, [assignedTagIds]);

  const field = () => {
    return [
      {
        key: 'value',
        label: 'Tags currently assigned to this conversation',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        options: tags.map((tag) => {
          return { label: tag.name, value: tag.id };
        }),
        component: (
          <TagSelect
            value={values}
            multi
            create
            config={{
              autoFocus: true,
              openOnFocus: true,
            }}
          />
        ),
        width: '100',
      },
    ];
  };

  const values = { value: newAssignedTagIds };

  const handleChange = (_key, value) => {
    setNewAssignedTagIds(value);
  };

  return (
    <GeckoModal
      name="Add tags to this conversation"
      children={
        <GeckoFields fields={field()} values={values} handler={handleChange} />
      }
      btns={[
        {
          name: 'Cancel',
          secondary: true,
          icon: 'fa fa-times',
          handler: () => {
            return new GeckoModalService().close();
          },
        },
        {
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          name: 'Done',
          icon: 'far fa-check-double',
          handler: () => {
            GeckoRequest.post(`/tags/conversation-tags`, {
              conversation_id: conversation.id,
              tag_ids: newAssignedTagIds,
            })
              .then(() => {
                new GeckoModalService().close();
                new GeckoToastService().success(
                  'Tags added / edited successfully'
                );
                setActionTimestamp(Date.now());
              })
              .catch(renderError);
          },
        },
      ]}
    />
  );
};

export default AddTagsModal;
